import config from "../../../config/common";

const getUpSellCarouselAdjustedPosition = advertPosition => {
  const {
    upsell: { carouselPosition }
  } = config;

  return advertPosition !== null && advertPosition <= carouselPosition
    ? carouselPosition + 1
    : carouselPosition;
};

export default getUpSellCarouselAdjustedPosition;
